<template>
  <div class="footer-container">
    <div class="footer">
      Copyright © www.ceea500.org.cn All Rights Reserved 中国企业评价协会 版权所有 <a href="https://beian.miit.gov.cn"
        target="_blank">京ICP备05067252号-2</a> <img src="../../../assets/image/gaico.png" border="0"><a
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502053906"
        target="_blank">京公网安备11010502053906号</a>
    </div>
  </div>
</template>

<script>

export default {
  components: {

  },
  data() {
    return {

    }
  },



  mounted() {

  },
  created() {

  },
  methods: {


  },
};
</script>

<style lang="scss" scoped>
// .footer-container{
//   position: fixed;
//   width: 100%;
//   left: 0;
//   bottom: 0;
// }

.footer {
  text-align: center;
  background: #000000;
  font-size: 12px;
  padding: 25px 0;
  color: #fff;
}

.footer {
  width: 100%;
  margin: 0 auto;
}
a{
  color: #666;
}
</style>
